import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { FeatureFlagsEnum } from '../../shared/enums';
import { FeatureFlagService } from '../../shared/services';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export const LaunchDarklyActivateGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> =>  {
    return inject(FeatureFlagService).getFlag(route.data['featureFlag'] as FeatureFlagsEnum);
}
